import React, { useEffect, useState } from "react";
import {
  getInitials as getDefaultInitials,
  resolveMemberAvatarUrl,
  resolveMemberDisplayName,
} from "utils/tasks/taskHelpers";

const MemberAvatar = ({
  member,
  siteMembers = [],
  getInitials = getDefaultInitials,
  className = "",
  imageClassName = "",
  fallbackClassName = "",
  style,
  title,
}) => {
  const avatarUrl = resolveMemberAvatarUrl(member, siteMembers);
  const displayName = resolveMemberDisplayName(member, siteMembers);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [avatarUrl]);

  if (avatarUrl && !imageFailed) {
    return (
      <img
        src={avatarUrl}
        alt={displayName}
        className={`${className} ${imageClassName}`.trim()}
        style={style}
        title={title || displayName}
        onError={() => setImageFailed(true)}
      />
    );
  }

  return (
    <span
      className={`${className} ${fallbackClassName}`.trim()}
      style={style}
      title={title || displayName}
    >
      {getInitials(displayName)}
    </span>
  );
};

export default MemberAvatar;
